<template>
  <br />
  <div class="row">
    <div class="alert alert-success" role="alert" v-if="successMessage" >
        {{ successMessage}}
    </div>
    <div class="alert alert-danger" role="alert" v-if="errorMessage">
        {{ errorMessage }}
    </div>
    <div class="col-xxl-3 col-xl-4 col-lg-6 col-md-6 col-sm-12 mb-3">
      <button type="button" class="btn btn-primary" data-bs-target="#createContentCategoryModal" data-bs-toggle="modal"
        :disabled="disableCreate">
        <span v-if="!disableCreate">Create category</span>
        <span v-else><font-awesome-icon icon="fa-solid fa-sync" spin /></span>
      </button>
    </div>
  </div>
  <div style="padding:5px" class="row">
    <div class="col-lg-6 col-md-12 mb-3">
      <label for="content-category-country" class="form-label me-2 mt-1">Country</label>
      <select
        id="content-category-country"
        class="form-control"
        v-model="countryFilter"
        @change="onCountryChange"
      >
        <option value="">All</option>
        <option v-for="code in availableCountries" :key="code" :value="code">{{ code }}</option>
      </select>
    </div>
    <div class="col-lg-6 col-md-12 mb-3">
      <label for="content-category-per-page" class="form-label me-2 mt-2">Per page</label>
      <select id="content-category-per-page" class="form-control" v-model="perPage" @change="perPageFilter(perPage)">
        <option :value="10">10</option>
        <option :value="20">20</option>
        <option :value="50">50</option>
        <option :value="100">100</option>
      </select>
    </div>
  </div>
  <div class="table-responsive">
    <table class="table">
      <thead>
        <tr>
          <th scope="col" @click="orderByFilter('id')" style="cursor: pointer;">
            Id
            <font-awesome-icon v-if="sort === 'id' && direction === 'asc'" icon="fa-solid fa-sort-up" style="margin-left: 5px;"/>
            <font-awesome-icon v-else-if="sort === 'id' && direction === 'desc'" icon="fa-solid fa-sort-down" style="margin-left: 5px;"/>
          </th>
          <th scope="col" @click="orderByFilter('name')" style="cursor: pointer;">
            Name
            <font-awesome-icon v-if="sort === 'name' && direction === 'asc'" icon="fa-solid fa-sort-up" style="margin-left: 5px;"/>
            <font-awesome-icon v-else-if="sort === 'name' && direction === 'desc'" icon="fa-solid fa-sort-down" style="margin-left: 5px;"/>
          </th>
          <th scope="col" @click="orderByFilter('position')" style="cursor: pointer;">
            Position
            <font-awesome-icon v-if="sort === 'position' && direction === 'asc'" icon="fa-solid fa-sort-up" style="margin-left: 5px;"/>
            <font-awesome-icon v-else-if="sort === 'position' && direction === 'desc'" icon="fa-solid fa-sort-down" style="margin-left: 5px;"/>
          </th>
          <th scope="col" @click="orderByFilter('active_creators')" style="cursor: pointer;">
            Creators
            <small class="d-block text-muted">Public / all</small>
            <font-awesome-icon v-if="sortForCreatorsColumn && direction === 'asc'" icon="fa-solid fa-sort-up" style="margin-left: 5px;"/>
            <font-awesome-icon v-else-if="sortForCreatorsColumn && direction === 'desc'" icon="fa-solid fa-sort-down" style="margin-left: 5px;"/>
          </th>
          <th scope="col">Action</th>
        </tr>
      </thead>
      <tbody>
        <tr v-if="contentCategories.length > 0" v-for="contentCategory in contentCategories" :key="contentCategory.id">
          <td>{{contentCategory.id}}</td>
          <td>{{ contentCategory.name }}</td>
          <td>{{ contentCategory.position }}</td>
          <td>{{ activeCreatorsCount(contentCategory) }} / {{ creatorsCount(contentCategory) }}</td>
          <td>
              <button type="button" class="btn btn-info" data-bs-target="#updateContentCategoryModal" data-bs-toggle="modal"
                :disabled="disableCreate" @click="openUpdateContentCategoryModal(contentCategory.id)">
                <span v-if="!disableCreate">Edit</span>
                <span v-else><font-awesome-icon icon="fa-solid fa-sync" spin /></span>
              </button>
              <button
                v-if="isEmptyCategory(contentCategory)"
                type="button"
                class="btn btn-danger ms-2"
                :disabled="deletingCategoryId === contentCategory.id"
                @click="deleteContentCategory(contentCategory)"
              >
                <span v-if="deletingCategoryId !== contentCategory.id">Delete</span>
                <span v-else><font-awesome-icon icon="fa-solid fa-sync" spin /></span>
              </button>
          </td>
        </tr>
        <tr v-else-if="loading">
          <td colspan="5" class="text-center"><font-awesome-icon icon="fa-solid fa-sync" spin /></td>
        </tr>
        <tr v-else>
          <td colspan="5" class="text-center">No categories</td>
        </tr>
      </tbody>
    </table>
    <div class="d-flex justify-content-between" v-if="totalRecords >= 1">
      <div>
        <div class="p-2">
          <p>Total categories: {{ totalRecords }}</p>
        </div>
      </div>
      <div>
        <div class="p-2">
          <nav v-if="totalPages >= 1" aria-label="Content categories pagination">
            <ul class="pagination">
              <li class="page-item" :class="{disabled: currentPage - 1 < 1}">
                <a @click="paginate(currentPage - 1)" class="page-link">Previous</a>
              </li>
              <li class="page-item" :class="{active: 1 === currentPage}">
                <a @click="paginate(1)" class="page-link" :class="{'not-clickable': currentPage === 1}">1</a>
              </li>
              <li v-if="currentPage - 2 > 1" class="page-item">
                <a href="#" class="page-link">...</a>
              </li>
              <li class="page-item" v-if="currentPage - 2 > 1">
                <a @click="paginate(currentPage - 2)" class="page-link">{{ currentPage - 2}}</a>
              </li>
              <li class="page-item" v-if="currentPage - 1 > 1">
                <a @click="paginate(currentPage - 1)" class="page-link">{{ currentPage - 1}}</a>
              </li>
              <li class="page-item" v-if="currentPage !== 1"  :class="{active: currentPage}">
                <a @click="paginate(currentPage)" class="page-link" :class="{'not-clickable': currentPage}">{{currentPage }}</a>
              </li>
              <li class="page-item" v-if="currentPage + 1 <= totalPages">
                <a @click="paginate(currentPage + 1)" class="page-link">{{ currentPage + 1}}</a>
              </li>
              <li class="page-item" v-if="currentPage + 2 <= totalPages">
                <a @click="paginate(currentPage + 2)" class="page-link">{{ currentPage + 2}}</a>
              </li>
              <li class="page-item" v-if="currentPage + 2 < totalPages">
                <a href="#" class="page-link">...</a>
              </li>
              <li class="page-item" v-if="currentPage !== totalPages && currentPage + 2 < totalPages" :class="{active: totalPages === currentPage}">
                <a @click="paginate(totalPages)" class="page-link" :class="{'not-clickable': totalPages === currentPage}">{{totalPages }}</a>
              </li>
              <li class="page-item" :class="{disabled: currentPage + 1 > totalPages}">
                <a @click="paginate(currentPage + 1)" class="page-link">Next</a>
              </li>
            </ul>
          </nav>
        </div>
      </div>
    </div>
  </div>
  <div class="modal fade" id="createContentCategoryModal" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1"
    aria-labelledby="staticBackdropLabel" aria-hidden="true">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h1 class="modal-title fs-5" id="staticBackdropLabel">Create content category form</h1>
          <button id="closeCreateContentCategoryBtn" type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <div class="mb-3">
            <label for="name" class="form-label">Name</label>
            <input type="text" class="form-control me-1" id="createContentCategoryName" v-model="createContentCategoryName">
            <p v-if="validationErrors" v-for="name in validationErrors.name" class="text-danger">{{ name }}</p>
          </div>
        </div>
        <div class="modal-footer">
          <button @click="createContentCategory(createContentCategoryName)"
            type="button" class="btn btn-dark-purple" :disabled="disableCreate">
            <span v-if="!disableCreate">Create</span>
            <span v-else><font-awesome-icon icon="fa-solid fa-sync" spin /></span>
          </button>
        </div>
      </div>
    </div>
  </div>
  <div class="modal fade" id="updateContentCategoryModal" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1"
    aria-labelledby="staticBackdropLabel" aria-hidden="true">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h1 class="modal-title fs-5" id="staticBackdropLabel">Update content category form <span v-if="disableCreate"><font-awesome-icon icon="fa-solid fa-sync" spin /></span></h1>
          <button id="closeUpdateContentCategoryBtn" type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <input type="text" class="form-control me-1" id="updateContentCategoryId" v-model="updateContentCategoryId" hidden>
          <div class="mb-3">
            <label for="name" class="form-label">Name</label>
            <input type="text" class="form-control me-1" id="updateContentCategoryName" v-model="updateContentCategoryName">
            <p v-if="validationErrors" v-for="name in validationErrors.name" class="text-danger">{{ name }}</p>
          </div>
          <div class="mb-3">
            <label for="name" class="form-label">Position</label>
            <input type="number" class="form-control me-1" id="updateContentCategoryPosition" v-model="updateContentCategoryPosition">
            <p v-if="validationErrors" v-for="name in validationErrors.position" class="text-danger">{{ name }}</p>
          </div>
        </div>
        <div class="modal-footer">
          <button 
            @click="updateContentCategory(updateContentCategoryId, updateContentCategoryName, updateContentCategoryPosition)"
            type="button" class="btn btn-dark-purple" :disabled="disableCreate">
            <span v-if="!disableCreate">Update</span>
            <span v-else><font-awesome-icon icon="fa-solid fa-sync" spin /></span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
  
  
  <script>
  import axios from 'axios';
  import _debounce from "lodash/debounce";
  import Swal from "sweetalert2";
  
  function applyContentCategoriesPayload(vm, body, requestedPage) {
    if (Array.isArray(body)) {
      vm.contentCategories = body;
      vm.totalRecords = body.length;
      vm.totalPages = 1;
      vm.currentPage = 1;
      return;
    }
    const d = body && typeof body === 'object' ? body : {};
    vm.contentCategories = Array.isArray(d.data) ? d.data : [];
    if (d.totalPages != null) {
      vm.totalPages = d.totalPages;
    } else {
      vm.totalPages = 1;
    }
    if (d.totalRecords != null) {
      vm.totalRecords = d.totalRecords;
    } else {
      vm.totalRecords = vm.contentCategories.length;
    }
    if (d.pageNumber != null) {
      vm.currentPage = d.pageNumber;
    } else {
      vm.currentPage = requestedPage;
    }
    const countries = d.meta && Array.isArray(d.meta.available_countries) ? d.meta.available_countries : null;
    if (countries) {
      vm.availableCountries = countries;
    }
  }
  
  export default {
    data() {
      return {
        loading: true,
        contentCategories: [],
        validationErrors : [],
        totalRecords: 0,
        currentPage: 1,
        totalPages: 0,
        perPage: 20,
        sort: 'position',
        direction: 'asc',
        countryFilter: '',
        availableCountries: [],
        disableCreate: false,
        deletingCategoryId: null,
        successMessage: "",
        errorMessage: "",
        createContentCategoryName : "",
        updateContentCategoryId : "",
        updateContentCategoryName : "",
        updateContentCategoryPosition : ""
      }
    },
  
    computed: {
      sortForCreatorsColumn() {
        return this.sort === 'active_creators' || this.sort === 'creators';
      }
    },
  
    mounted() {
        this.getContentCategories();
    },
  
    methods: {
      activeCreatorsCount(row) {
        const n = row && row.active_creators_count;
        return n != null && n !== '' ? n : 0;
      },
      creatorsCount(row) {
        const n = row && row.creators_count;
        return n != null && n !== '' ? n : 0;
      },
      isEmptyCategory(row) {
        return row && row.can_delete === true;
      },
      buildListQueryParams(page) {
        const params = new URLSearchParams();
        params.set('page', String(page));
        params.set('per_page', String(this.perPage));
        params.set('sort', this.sort);
        params.set('direction', this.direction);
        if (this.countryFilter && this.countryFilter.length === 2) {
          params.set('country', this.countryFilter);
        }
        return params.toString();
      },
      onCountryChange() {
        this.currentPage = 1;
        this.getContentCategories();
      },
      perPageFilter(perPage) {
        this.perPage = perPage;
        this.currentPage = 1;
        this.getContentCategories();
      },
      paginate(page) {
        if (this.totalPages > 0 && (page < 1 || page > this.totalPages)) return;
        this.currentPage = page;
        this.getContentCategories();
      },
      orderByFilter(column) {
        if (this.sort === column) {
          this.direction = this.direction === 'asc' ? 'desc' : 'asc';
        } else {
          this.direction = 'asc';
        }
        this.sort = column;
        this.currentPage = 1;
        this.getContentCategories();
      },
      debounceGetContentCategories: _debounce(function () {
        this.loading = true;
        const page = this.currentPage;
        const qs = this.buildListQueryParams(page);
        axios.get(`/admin/content-categories?${qs}`)
        .then(response => {
          applyContentCategoriesPayload(this, response.data, page);
          this.loading = false;
        })
        .catch(error => {
            this.loading = false;
            console.log(error);
        });
      }, 500),
      closeModal() {
        document.querySelector('#closeUpdateContentCategoryBtn').click();
        document.querySelector('#closeCreateContentCategoryBtn').click();
      },
      getContentCategories() {
        this.debounceGetContentCategories();
      },
      openUpdateContentCategoryModal(id) {
        this.disableCreate = true;
        axios.get(`/admin/content-categories/${id}`)
        .then(response => {
          let responseData = response.data;
          this.updateContentCategoryId = responseData.id;
          this.updateContentCategoryName = responseData.name;
          this.updateContentCategoryPosition = responseData.position;
          this.disableCreate = false;
        })
        .catch(error => {
          console.log(error);
          this.disableCreate = false;
        });
      },
      createContentCategory(createContentCategoryName) {
        this.disableCreate = true;
        axios.post('/admin/content-categories/create', {
          'name' : createContentCategoryName,
        })
        .then(response => {
          this.successMessage = "Category created successfuly";
          this.getContentCategories();
          this.resetContentCategoryParams();
          this.resetvalidationErrors();
          this.disableCreate = false;
          this.closeModal();
        })
        .catch(error => {
          if (error.response.status === 422) {
            this.validationErrors = error.response.data.errors;
          }
          this.disableCreate = false;
        });
      },
      updateContentCategory(updateContentCategoryId, updateContentCategoryName, updateContentCategoryPosition) {
        this.disableCreate = true;
        axios.put(`/admin/content-categories/update/${updateContentCategoryId}`, {
          'name' : updateContentCategoryName,
          'position' : updateContentCategoryPosition
        })
        .then(response => {
          this.successMessage = "Category content updated successfuly";
          this.getContentCategories();
          this.resetUpdateContentCategoryParams();
          this.resetvalidationErrors();
          this.disableCreate = false;
          this.closeModal();
        })
        .catch(error => {
          if (error.response.status === 422) {
            this.validationErrors = error.response.data.errors;
          }
          this.disableCreate = false;
        });
      },
      async deleteContentCategory(contentCategory) {
        const confirmation = await Swal.fire({
          title: 'Delete content category',
          text: `Are you sure you want to delete "${contentCategory.name}"?`,
          icon: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Delete',
          cancelButtonText: 'Cancel'
        });

        if (!confirmation.isConfirmed) {
          return;
        }

        this.deletingCategoryId = contentCategory.id;
        this.successMessage = "";
        this.errorMessage = "";

        try {
          const response = await axios.delete(`/admin/content-categories/${contentCategory.id}`);
          this.successMessage = response.data.message;

          if (this.contentCategories.length === 1 && this.currentPage > 1) {
            this.currentPage -= 1;
          }

          this.getContentCategories();
        } catch (error) {
          this.errorMessage = error.response?.data?.errors?.content_category?.[0]
            || error.response?.data?.message
            || 'Content category could not be deleted.';
        } finally {
          this.deletingCategoryId = null;
        }
      },
      resetUpdateContentCategoryParams() {
        this.updateContentCategoryId = "";
        this.updateContentCategoryName = "";
        this.updateContentCategoryPosition = "";
      },
      resetContentCategoryParams() {
        this.createContentCategoryName = "";
      },
      resetvalidationErrors() {
        this.validationErrors = [];
      }
  }

  }
  </script>
